import { ExportFileType } from 'common/types';
import { CheckType, GroupRulesEnum } from './checkJSON';

export const FILE_RULES_OF_DEFAULT_SHOW = [
  CheckType.FileSize,
  CheckType.FileType,
  CheckType.Channel,
  CheckType.Unit,
  CheckType.Resolution,
  CheckType.Version,
  GroupRulesEnum.MeshCount,
  GroupRulesEnum.Normalized,
  GroupRulesEnum.FaceCount,
  GroupRulesEnum.TriCount,
  // CheckType.FrameRate,
  // CheckType.TotalFrames,
  // 2024.5.8新增图片查重质检项
  CheckType.ImagePlagiarism,
  CheckType.ImageRisk,
];

export const FileExtToPreviewType = {
  jpg: ExportFileType.Image,
  jpeg: ExportFileType.Image,
  png: ExportFileType.Image,
  tga: ExportFileType.Other, // 0.7.1.1 模板外文件tga格式不经过质检转换，不能预览
  bmp: ExportFileType.Image,
  gif: ExportFileType.Image,
  webp: ExportFileType.Image,
  // svg: ExportFileType.Image, //安全问题禁止

  mp4: ExportFileType.Video,

  babylon: ExportFileType.Babylon,
  glb: ExportFileType.Babylon,
  gltf: ExportFileType.Babylon,

  ztl: ExportFileType.TurnTable,
  naraka_mobile_map: ExportFileType.LibraryTurntable,
  naraka_mobile_component: ExportFileType.LibraryTurntable,
};
export const FilterCheckItemMap = {
  [CheckType.AssetName]: 1,
  [CheckType.AssetId]: 2,
  [CheckType.FileType]: 2,
  [CheckType.FileSize]: 3,
  [CheckType.AssetType]: 4,
  [CheckType.AssetStyle]: 5,
  [CheckType.Label]: 5,
  [CheckType.UpdateTime]: 6,
  [CheckType.Summary]: 7,
  [CheckType.Topics]: 8,
  [CheckType.Score]: 9,
  [CheckType.ScoreNum]: 10,
  [CheckType.AuthorPass]: 11, // 是否通关
  [CheckType.OccupyNum]: 12,
  [CheckType.ItemNum]: 12,
  [CheckType.CollectNum]: 13,
  [CheckType.LikeNum]: 14,
  [CheckType.PlayNum]: 15,
  [CheckType.PassRate]: 16,
};
